import { Navigate, Outlet } from "react-router-dom";
import CookieUtils from "../utils/cookie-utils";
import { MODULE_ROUTE } from "./module-router";

export const ProtectedRoutes = () => {
  const token = CookieUtils.getCurrentUser().access_token ?? "";
  if (token === "") {
    return <Navigate to={MODULE_ROUTE.LOGIN} replace />;
  }

  return <Outlet />;
};
